import { render, staticRenderFns } from "./Telefonos.vue?vue&type=template&id=35512cbc"
import script from "./Telefonos.vue?vue&type=script&lang=ts"
export * from "./Telefonos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports